import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../css/Client.css";

const clients = [
  "bharatpe.png",
  "cashify.png",
  "meesho.png",
  "homelane.png",
  "indianoil.png",
  "magicbricks.png",
  "indiamart.png",
  "renewbuy.png",
  "limeroad.png",
  "qci.png",
  "cloudstructure.png",
  "livekeeping.png",
  "amazon.png",
  "cars24.png",
  "incred.png",
];

const Client = () => {
  return (
    <section className="client-section">
      <Container>

        {/* Testimonial */}
        <Row className="align-items-center mb-5">
          <Col lg={6}>
            <img
              src="/clients/meeting.jpg"
              alt="Client Meeting"
              className="img-fluid rounded"
            />
          </Col>

          <Col lg={6}>
            <div className="testimonial">
              <div className="stars">★★★★★</div>
              <h3>
                Nimbus BPO has saved us thousands of hours of work. We’re able
                to spin up new innovation faster.
              </h3>
            </div>
          </Col>
        </Row>

        {/* Trusted By */}
        <Card className="trusted-card">
          <Card.Body>
            <p className="text-center trusted-text">
              Trusted by 22+ Prestigious Companies & Counting more...
            </p>

            <Row className="justify-content-center align-items-center">
              {clients.map((logo, index) => (
                <Col
                  key={index}
                  lg={2}
                  md={3}
                  sm={4}
                  xs={6}
                  className="text-center mb-4"
                >
                  <img
                    src={`/clients/${logo}`}
                    alt="Client Logo"
                    className="client-logo"
                  />
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

      </Container>
    </section>
  );
};

export default Client;
